import { ApiAuthorization, ApiDataModel, ApiModule } from '@/api/apiConstants'

const groupPrefix = createApiRoute(
	ApiModule.PRODUCTION_PLANNING,
	ApiAuthorization.EMPLOYEE,
	ApiDataModel.TABLET_WORKERS,
)
const simulationsPrefix = createApiRoute(
	ApiModule.PRODUCTION_PLANNING,
	ApiAuthorization.EMPLOYEE,
	ApiDataModel.SIMULATIONS,
)

export const apiProductionEmployees = {
	fetchProductionEmployees: async (
		productionRole: EProductionEmployeeRole[] | undefined,
		search: string | undefined,
		isActive: boolean | undefined = undefined,
		page: number = 1,
		perPage: number = 25,
		sort?: Record<string, EApiSortType>,
	): Promise<{ data: IProductionEmployeeModel[]; meta?: IApiMetaModel }> => {
		const { data, meta } = await apiCommon<IProductionEmployee[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery({ page, perPage }, { production_role: productionRole, is_active: isActive, search }, sort),
		})

		return { data: data.map(employee => ProductionEmployee(employee)), meta }
	},

	createProductionEmployee: async (obj: IProductionEmployeeJson): Promise<IProductionEmployeeModel> => {
		const { data } = await apiCommon<IProductionEmployee>(`${groupPrefix}`, {
			method: 'POST',
			body: productionEmployeeToJSON(obj),
		})

		return ProductionEmployee(data)
	},

	updateProductionEmployee: async (id: number, obj: IProductionEmployeeJson): Promise<IProductionEmployeeModel> => {
		const { data } = await apiCommon<IProductionEmployee>(`${groupPrefix}/${id}`, {
			method: 'PUT',
			body: productionEmployeeToJSON(obj),
		})

		return ProductionEmployee(data)
	},

	deleteProductionEmployee: async (id: number): Promise<void> => {
		await apiCommon(`${groupPrefix}/${id}`, {
			method: 'DELETE',
		})
	},

	assignWorkerToRecipes: async (
		simulationId: number,
		recipeIds: number[],
		place: string,
		tabletWorkerId: number,
		productId: number | null = null,
	): Promise<void> => {
		await apiCommon(`${simulationsPrefix}/${simulationId}/recipe-worker-assignments`, {
			method: 'POST',
			body: {
				place,
				recipe_ids: recipeIds,
				tablet_worker_id: tabletWorkerId,
				product_id: productId,
			},
		})
	},

	unassignWorkerFromRecipes: async (
		simulationId: number,
		recipeIds: number[],
		place: string,
		tabletWorkerId: number,
		productId: number | null = null,
	): Promise<void> => {
		await apiCommon(`${simulationsPrefix}/${simulationId}/recipe-worker-assignments/unassign`, {
			method: 'POST',
			body: {
				place,
				recipe_ids: recipeIds,
				tablet_worker_id: tabletWorkerId,
				product_id: productId,
			},
		})
	},
}
